import { Controller } from "@hotwired/stimulus"
import mpegts from "mpegts.js"

export default class extends Controller {
  static values = { url: String, format: String }
  static targets = ["video", "hint"]

  connect() {
    const video = this.videoTarget
    video.addEventListener("error", () => this.#showHint())
    video.addEventListener("loadeddata", () => {
      if (video.videoWidth === 0) this.#showHint()
    })

    if (this.formatValue === "ts" && mpegts.isSupported()) {
      video.addEventListener("play", () => this.#startMpegts(), { once: true })
    } else {
      video.src = this.urlValue
    }
  }

  disconnect() {
    this.player?.destroy()
    this.player = null
  }

  #startMpegts() {
    this.player = mpegts.createPlayer({ type: "mpegts", isLive: false, url: this.urlValue })
    this.player.on(mpegts.Events.ERROR, () => this.#showHint())
    this.player.attachMediaElement(this.videoTarget)
    this.player.load()
    this.videoTarget.play().catch(() => {})
  }

  #showHint() {
    this.hintTarget.classList.remove("hidden")
  }
}
